export function label(question, questions, prompt) {
  return `Photo ${
    questions
      .filter(item => item.type === 'picture')
      .findIndex(item => item.id === question.id) + 1
  } - ${prompt}`
}
